<p>Welcome to EXPLORE apllication</p>

<button (click)="ShowProfile()">ShowProfile</button>

<!-- KEYCLOAK -->
<!-- <button (click)="login()" *ngIf="!keycloak.isLoggedIn()">Login</button>
<button (click)="logout()" *ngIf="keycloak.isLoggedIn()">Logout</button>
<div *ngIf="keycloak.isLoggedIn()">
  <h3>Welcome, {{ keycloak.getUsername() }}</h3>
</div> -->
<!-- END -->